import SidebarNavItem from "./SidebarNavItem.jsx";
import SidebarRailTooltip from "./SidebarRailTooltip.jsx";
import NewTaskIcon from "../Icons/newTaskIcon.jsx";
import { useSelector } from "react-redux";
import { selectUser } from "../../store/slices/authSlice";

export default function SidebarNav({ newTaskPath, onNavigate, items, isCollapsed = false }) {
  const user = useSelector(selectUser);
  const isAdmin = user?.role?.toLowerCase() === "admin";

  return (
    <div className="nav-group">
      {isAdmin ? (
        <SidebarRailTooltip text="New task" enabled={isCollapsed}>
          <button
            className="nav-create-btn"
            type="button"
            onClick={() => onNavigate(newTaskPath)}
            aria-label={isCollapsed ? "New task" : undefined}
          >
            <span className="nav-icon">
              <NewTaskIcon size={14} />
            </span>
            <span className="nav-label">New task</span>
          </button>
        </SidebarRailTooltip>
      ) : null}

      {items.map((item) => (
        <SidebarNavItem
          key={item.path}
          as="button"
          active={item.active}
          disabled={item.disabled}
          label={item.label}
          icon={item.icon}
          badge={item.badge}
          dataPage={item.dataPage}
          collapsed={isCollapsed}
          onClick={() => onNavigate(item.path)}
        />
      ))}
    </div>
  );
}

